// eslint-disable-line eqeqeq
import React from 'react';
import LoadingSpinner from './loadingSpinner'
// import C18DateFormat00 from './C18DateFormat00'
// import C18Button00 from './C18Button00'
// import C18Anchor00 from './C18Anchor00'
import C18Select01 from './C18Select01'
import {getParamId2,getPearlUsed,getPearlNumIO,gmbAddXBoardShorts,
  xBoardShorts,genericTypes,pearlMappingTypeNames,
} from '../utils/utils'
import {pInd} from '../../components/utils/paramIds'
import {dbVals,putZValue,sendArray} from '../../components/utils/http';
import {lc,pearlSensorIds} from '../../components/utils/landruConstants'
import {loadSitesInfo,loadZonesInfo,getZoneIndex,loadSiteData,getChannelType,
  getSiteName,getZoneName,getZoneInfo,loadSensorsInfo,getSensorsZone,} from './C18utils'
// import {getEquipmentStatus} from './C18EquipmentStatus00'
// import {dbVals,getZoneControllers} from '../../components/utils/http';
import {cl,globs,getTimeI,constant,supportsFallbackHum,supportsGenericEmaTc} from '../../components/utils/utils';
// import {pInd} from '../../components/utils/paramIds';
//
// import history from "../../history"

class C18PearlMapping00 extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.inputIds={
      "0":"None",
      "1":"Serial Sensor 1",
      "2":"Serial Sensor 2",
      "3":"Analog Input 1",
      "4":"Analog Input 2",
      "5":"Analog Input 3",
      "6":"Analog Input 4",
      "7":"Analog Input 5",
      "8":"Analog Input 6",
      "9":"Analog Input 7",
      "10":"Analog Input 8",
      "11":"Fast Digital 1",
      "12":"Fast Digital 2",
      "13":"Fast Digital 3",
      "14":"Digital Input 1",
      "15":"Digital Input 2",
      "16":"Digital Input 3",
      "17":"Digital Input 4",
      "18":"Digital Input 5",
      "19":"Digital Input 6",
      "20":"Digital Input 7",
      "21":"Digital Input 8",
      "22":"Software",
      "23":"Remote",
      "24":"Exp Analog 1",
      "25":"Exp Analog 1",
      "26":"Sensor Module",
      "27":"Digital Temp / Hum",
      "28":"Sensor Module Backup",
      "29":"Modbus Input",
      "100":"Zone 1",
      "101":"Zone 2",
      "102":"Zone 3",
      "103":"Zone 4",
      "104":"Zone 5",
      "105":"Zone 6",
      "106":"Zone 7",
      "107":"Zone 8",
      "108":"Zone 9",
      "109":"Zone 10",
      "110":"Zone 11",
      "111":"Zone 12",
      "112":"Zone 13",
      "113":"Zone 14",
      "114":"Zone 15",
      "115":"Zone 16",
      "116":"Zone 17",
      "117":"Zone 18",
      "118":"Zone 19",
      "119":"Zone 20",
      "120":"Zone 21",
      "121":"Zone 22",
      "122":"Zone 23",
      "123":"Zone 24",
      "124":"Zone 25",
      "125":"Zone 26",
      "126":"Zone 27",
      "127":"Zone 28",
      "128":"Zone 29",
      "129":"Zone 30",
      "130":"Zone 31",
      "131":"Zone 32",
    }
//     this.genericTypes=[
//       {v:0,t:"None"},
//       {v:1,t:"Generic"},
//       {v:2,t:"Software"},
//       {v:3,t:"Temp",u:"\u00B0"},
//       {v:4,t:"Hum",u:"% RH"},
//       {v:5,t:"DHT Temp",u:"\u00B0"},
//       {v:6,t:"DHT Hum",u:"% RH"},
//       {v:7,t:"Rain"},
//       {v:8,t:"Wind Speed",u:"Mph"},
//       {v:9,t:"Wind Dir"},
//       {v:10,t:"Voltage",u:"V"},
//       {v:11,t:"Light",u:"uMol"},
//       {v:12,t:"BHeat",u:"\u00B0"},
//       {v:13,t:"Moisture",u:"%"},
//       {v:14,t:"Diff Press",u:"Kpa"},
//       {v:15,t:"Digital Inp"},
//       {v:16,t:"Dissolved Oxygen",u:"mg/Ltr"},
//       {v:17,t:"Flow Rate",u:"Gpm"},
//       {v:18,t:"Distance",u:"gal"},
//       {v:19,t:"pH"},
//       {v:20,t:"EC",u:"uS"},
//       {v:21,t:"Gen Temp",u:"\u00B0"},
//     ]
    this.inputTypes={
      inTemp:{type:"ins",opts:[0,1,2,26,27,29,22,23,26,]},
      inHum:{type:"ins",opts:[0,1,2,27,29,22,23,26]},
      inLight:{type:"ins",opts:[0,3,4,5,6,7,29,22,23,26,29]},
      inCo2:{type:"ins",opts:[0,22,23,26,29]},
      fbInTemp:{type:"ins",opts:[0,1,2,26,27,29,22,23,26,]},
      fbInHum:{type:"ins",opts:[0,1,2,27,29,22,23,26]},
      diffP:{type:"ins",opts:[0,3,4,5,6,7,29,22]},
      baro:{type:"ins",opts:[0,3,4,5,6,7,29,22]},
      irrTrig:{type:"ins",opts:[0,26,29,22,23]},
      vent1:{type:"ins",opts:[0,26,29,22,23]},
      vent2:{type:"ins",opts:[0,26,29,22,23]},
      vent3:{type:"ins",opts:[0,26,29,22,23]},
      vent4:{type:"ins",opts:[0,26,29,22,23]},
      vent5:{type:"ins",opts:[0,26,29,22,23]},
      soil1:{type:"ins",opts:[0,26,29,22,23]},
      soil2:{type:"ins",opts:[0,26,29,22,23]},
      soil3:{type:"ins",opts:[0,26,29,22,23]},
      soil4:{type:"ins",opts:[0,26,29,22,23]},
      soil5:{type:"ins",opts:[0,26,29,22,23]},
      locInTemp:{type:"ins",opts:[0,1,2,26,27,29,22,23]},
      locInHum:{type:"ins",opts:[0,1,2,27,29,22,23,26]},

      outTemp:{type:"out",opts:[0,1,2,27,29,22,23]},
      bpTemp:{type:"out",opts:[0,1,2,3,4,5,6,7,29,22,23]},
      outHum:{type:"out",opts:[0,1,2,27,29,22,23]},
      outLight:{type:"out",opts:[0,29,22,23,26]},
      wndSpd:{type:"out",opts:[0,29,22,23]},
      wndDir:{type:"out",opts:[0,9,29,22,23]},
      rain:{type:"out",opts:[0,11,12,13,29,22,23]},
      snow:{type:"out",opts:[0,14,15,16,17,18,19,20,21,29,22,23]},
//       buTemp:{type:"out",opts:[0,1,2,26,27,29,22,23]},

      anTemp1:{type:"tmp",opts:[0,1,2,26,27,29,22,23]},
      anTemp2:{type:"tmp",opts:[0,1,2,26,27,29,22,23]},
      anTemp3:{type:"tmp",opts:[0,1,2,26,27,29,22,23]},
      anTemp4:{type:"tmp",opts:[0,1,2,26,27,29,22,23]},
      anTemp5:{type:"tmp",opts:[0,1,2,26,27,29,22,23]},
      exTemp1:{type:"tmp",opts:[0,29]},
      exTemp2:{type:"tmp",opts:[0,29]},
      exTemp3:{type:"tmp",opts:[0,29]},
      exTemp4:{type:"tmp",opts:[0,29]},
      exTemp5:{type:"tmp",opts:[0,29]},
      exTemp6:{type:"tmp",opts:[0,29]},
      exTemp7:{type:"tmp",opts:[0,29]},
      exTemp8:{type:"tmp",opts:[0,29]},
      exTemp9:{type:"tmp",opts:[0,29]},
      exTemp10:{type:"tmp",opts:[0,29]},
      exTemp11:{type:"tmp",opts:[0,29]},
      exTemp12:{type:"tmp",opts:[0,29]},
      exTemp13:{type:"tmp",opts:[0,29]},
      exTemp14:{type:"tmp",opts:[0,29]},
      exTemp15:{type:"tmp",opts:[0,29]},
      exTemp16:{type:"tmp",opts:[0,29]},
      exTemp17:{type:"tmp",opts:[0,29]},
      exTemp18:{type:"tmp",opts:[0,29]},
      exTemp19:{type:"tmp",opts:[0,29]},

      volt1:{type:"vlt",opts:[0,29]},
      volt2:{type:"vlt",opts:[0,29]},
      volt3:{type:"vlt",opts:[0,29]},
      volt4:{type:"vlt",opts:[0,29]},
      volt5:{type:"vlt",opts:[0,29]},
      volt6:{type:"vlt",opts:[0,29]},
      volt7:{type:"vlt",opts:[0,29]},
      volt8:{type:"vlt",opts:[0,29]},

      genSens1:{type:"gn0",opts:[0,29]},
      genSens2:{type:"gn0",opts:[0,29]},
      genSens3:{type:"gn0",opts:[0,29]},
      genSens4:{type:"gn0",opts:[0,29]},
      genSens5:{type:"gn0",opts:[0,29]},
      genSens6:{type:"gn0",opts:[0,29]},
      genSens7:{type:"gn0",opts:[0,29]},
      genSens8:{type:"gn0",opts:[0,29]},
      genSens9:{type:"gn0",opts:[0,29]},
      genSens10:{type:"gn0",opts:[0,29]},
      genSens11:{type:"gn0",opts:[0,29]},
      genSens12:{type:"gn0",opts:[0,29]},
      genSens13:{type:"gn0",opts:[0,29]},
      genSens14:{type:"gn0",opts:[0,29]},
      genSens15:{type:"gn0",opts:[0,29]},
      genSens16:{type:"gn0",opts:[0,29]},
      genSens17:{type:"gn0",opts:[0,29]},
      genSens18:{type:"gn0",opts:[0,29]},
      genSens19:{type:"gn0",opts:[0,29]},
      genSens20:{type:"gn0",opts:[0,29]},
      genSens21:{type:"gn0",opts:[0,29]},
      genSens22:{type:"gn0",opts:[0,29]},
      genSens23:{type:"gn0",opts:[0,29]},
      genSens24:{type:"gn0",opts:[0,29]},
      genSens25:{type:"gn0",opts:[0,29]},

      genSens26:{type:"gn1",opts:[0,29]},
      genSens27:{type:"gn1",opts:[0,29]},
      genSens28:{type:"gn1",opts:[0,29]},
      genSens29:{type:"gn1",opts:[0,29]},
      genSens30:{type:"gn1",opts:[0,29]},
      genSens31:{type:"gn1",opts:[0,29]},
      genSens32:{type:"gn1",opts:[0,29]},
      genSens33:{type:"gn1",opts:[0,29]},
      genSens34:{type:"gn1",opts:[0,29]},
      genSens35:{type:"gn1",opts:[0,29]},
      genSens36:{type:"gn1",opts:[0,29]},
      genSens37:{type:"gn1",opts:[0,29]},
      genSens38:{type:"gn1",opts:[0,29]},
      genSens39:{type:"gn1",opts:[0,29]},
      genSens40:{type:"gn1",opts:[0,29]},
      genSens41:{type:"gn1",opts:[0,29]},
      genSens42:{type:"gn1",opts:[0,29]},
      genSens43:{type:"gn1",opts:[0,29]},
      genSens44:{type:"gn1",opts:[0,29]},
      genSens45:{type:"gn1",opts:[0,29]},
      genSens46:{type:"gn1",opts:[0,29]},
      genSens47:{type:"gn1",opts:[0,29]},
      genSens48:{type:"gn1",opts:[0,29]},
      genSens49:{type:"gn1",opts:[0,29]},
      genSens50:{type:"gn1",opts:[0,29]},

      genSens51:{type:"gn2",opts:[0,29]},
      genSens52:{type:"gn2",opts:[0,29]},
      genSens53:{type:"gn2",opts:[0,29]},
      genSens54:{type:"gn2",opts:[0,29]},
      genSens55:{type:"gn2",opts:[0,29]},
      genSens56:{type:"gn2",opts:[0,29]},
      genSens57:{type:"gn2",opts:[0,29]},
      genSens58:{type:"gn2",opts:[0,29]},
      genSens59:{type:"gn2",opts:[0,29]},
      genSens60:{type:"gn2",opts:[0,29]},
      genSens61:{type:"gn2",opts:[0,29]},
      genSens62:{type:"gn2",opts:[0,29]},
      genSens63:{type:"gn2",opts:[0,29]},
      genSens64:{type:"gn2",opts:[0,29]},
      genSens65:{type:"gn2",opts:[0,29]},
      genSens66:{type:"gn2",opts:[0,29]},
      genSens67:{type:"gn2",opts:[0,29]},
      genSens68:{type:"gn2",opts:[0,29]},
      genSens69:{type:"gn2",opts:[0,29]},
      genSens70:{type:"gn2",opts:[0,29]},
      genSens71:{type:"gn2",opts:[0,29]},
      genSens72:{type:"gn2",opts:[0,29]},
      genSens73:{type:"gn2",opts:[0,29]},
      genSens74:{type:"gn2",opts:[0,29]},
      genSens75:{type:"gn2",opts:[0,29]},

      genSens76:{type:"gn3",opts:[0,29]},
      genSens77:{type:"gn3",opts:[0,29]},
      genSens78:{type:"gn3",opts:[0,29]},
      genSens79:{type:"gn3",opts:[0,29]},
      genSens80:{type:"gn3",opts:[0,29]},
      genSens81:{type:"gn3",opts:[0,29]},
      genSens82:{type:"gn3",opts:[0,29]},
      genSens83:{type:"gn3",opts:[0,29]},
      genSens84:{type:"gn3",opts:[0,29]},
      genSens85:{type:"gn3",opts:[0,29]},
      genSens86:{type:"gn3",opts:[0,29]},
      genSens87:{type:"gn3",opts:[0,29]},
      genSens88:{type:"gn3",opts:[0,29]},
      genSens89:{type:"gn3",opts:[0,29]},
      genSens90:{type:"gn3",opts:[0,29]},
      genSens91:{type:"gn3",opts:[0,29]},
      genSens92:{type:"gn3",opts:[0,29]},
      genSens93:{type:"gn3",opts:[0,29]},
      genSens94:{type:"gn3",opts:[0,29]},
      genSens95:{type:"gn3",opts:[0,29]},
      genSens96:{type:"gn3",opts:[0,29]},
      genSens97:{type:"gn3",opts:[0,29]},
      genSens98:{type:"gn3",opts:[0,29]},
      genSens99:{type:"gn3",opts:[0,29]},
      genSens100:{type:"gn3",opts:[0,29]},

      genSens101:{type:"gn4",opts:[0,29]},
      genSens102:{type:"gn4",opts:[0,29]},
      genSens103:{type:"gn4",opts:[0,29]},
      genSens104:{type:"gn4",opts:[0,29]},
      genSens105:{type:"gn4",opts:[0,29]},
      genSens106:{type:"gn4",opts:[0,29]},
      genSens107:{type:"gn4",opts:[0,29]},
      genSens108:{type:"gn4",opts:[0,29]},
      genSens109:{type:"gn4",opts:[0,29]},
      genSens110:{type:"gn4",opts:[0,29]},
      genSens111:{type:"gn4",opts:[0,29]},
      genSens112:{type:"gn4",opts:[0,29]},
      genSens113:{type:"gn4",opts:[0,29]},
      genSens114:{type:"gn4",opts:[0,29]},
      genSens115:{type:"gn4",opts:[0,29]},
      genSens116:{type:"gn4",opts:[0,29]},
      genSens117:{type:"gn4",opts:[0,29]},
      genSens118:{type:"gn4",opts:[0,29]},
      genSens119:{type:"gn4",opts:[0,29]},
      genSens120:{type:"gn4",opts:[0,29]},
      genSens121:{type:"gn4",opts:[0,29]},
      genSens122:{type:"gn4",opts:[0,29]},
      genSens123:{type:"gn4",opts:[0,29]},
      genSens124:{type:"gn4",opts:[0,29]},
      genSens125:{type:"gn4",opts:[0,29]},
      genSens126:{type:"gn4",opts:[0,29]},
      genSens127:{type:"gn4",opts:[0,29]},
      genSens128:{type:"gn4",opts:[0,29]},
//       loTemp:[0,1,2,26,27,29,22,23],
    }
    this.state={
      loaded:false,
    }
//     cl("load info")
    this.loadInfo()
//     this.setBreadCrumbs()
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent",this.savePage)
  }

  setBreadCrumbs=async()=>{
    await loadSitesInfo()
    await loadZonesInfo()
    let siteName=getSiteName(this.props.parms.site)
    let zoneName=getZoneName(this.props.parms.zone)
    let gwType=getZoneInfo(this.props.parms.zone)?.gatewayType||1800
    let type=this.getMapType()
//     let typeNames={
//       ins:"Inside",
//       out:"Outside",
//       tmp:"Temperature",
//       vlt:"Voltage",
//       gn0:"Generic 1-25",
//       gn1:"Generic 26-50",
//       gn2:"Generic 51-75",
//       gn3:"Generic 76-100",
//       gn4:"Generic 101-128",
//     }
    let mapName=(type)?pearlMappingTypeNames[type]:"Pearl"
    let mapLink=(type)?`?type=${type}`:""
    this.props.parms.onChange(
      {
        cmd: "breadcrumbs",
        data:
          {breadcrumbs: [
            {t:"Sites", url:"/usa/c18/sites"},
            {t:siteName, url:`/usa/c18/sites/${this.props.parms.site}`},
            {t:zoneName, url:`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}`},
            {t:`Sensor Settings`, url:`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}/settings/sensor${gwType}`},
            {t:`Input Mapping`, url:`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}/settings/mapping`},
            {t:`${mapName} Mapping`, url:`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}/pearl/mapping${mapLink}`},
          ]},
      },
    )
  }

  componentWillUnmount=()=>{
    if(this.subscribe_savePageEvent){this.subscribe_savePageEvent.remove()}
  }

  savePage=(cmd)=>{
    if(!this.pageChanged){return}
    let zInd=this.zone.siteZoneIndex
    let ch=240
    let arr=[]
    let now=getTimeI()
    var putVal=(nVals,oVals,name,ofs,id)=>{
//       cl(nVals)
//       cl(oVals)
//       if(nVals[name]!=oVals[name]){
//         cl(name)
        let i=ofs+this.inpMapIds[id]
//         cl(nVals,name)
        let d=nVals[name]

//         if(putZValue(zInd,ch,i,d)){
          putZValue(zInd,ch,i,d)
//           cl("push")
          arr.push({
            c:ch,
            d:d,
            f:2,
            i:i,
            t:now,
            z:zInd,
          })
//         }
//       }
    }
    if(cmd=="save"){
//       cl("save")
      let st=this.state
//       cl(st)
      let inputs=st.inputs.slice(0)
      let imi=this.inpMapIds;
      let type=this.getMapType()
      Object.keys(this.inputTypes)
        .filter(k=>(type)?(this.inputTypes[k].type==type):true)
        .filter(this.showInputType)
        .forEach(k=>{
//           cl(k)
          let id=pearlSensorIds[k].i
          inputs[id].save=true
        })
//       let ici=this.inpCfgIds
//       cl(this.initInputs[79])
//       cl(inputs)
      inputs.forEach((inp,i)=>{
        if(inp.save){
//           cl(i,inp)
          if(i<imi.entCnt){
  //           if(inp!=this.initInputs[i]){
  //             cl(inp)
              let ofs=i*this.inpMapIds.entSize
              let inpI=this.initInputs[i]
              putVal(inp,inpI,"mapping",ofs,"mappingId")
              putVal(inp,inpI,"channel",ofs,"channelId")
              putVal(inp,inpI,"board",ofs,"boardId")
              this.initInputs[i]=Object.assign({},inp)// update "old" values
  //           }
          }else{
  //           cl(inp)
  //           if(inp!=this.initInputs[i]){
  //             cl(inp)
              let ofs=(i-imi.entCnt)*imi.entSize2
  //             let ofs=i*this.inpMapIds.entSize
              let inpI=this.initInputs[i]
              putVal(inp,inpI,"mapping",ofs,"mappingId2")
              putVal(inp,inpI,"channel",ofs,"channelId2")
              putVal(inp,inpI,"board",ofs,"boardId2")
              putVal(inp,inpI,"sensorType",ofs,"typeId2")
              this.setLightEmaTc(inp,inpI,ofs,zInd,ch,now,arr)
              this.initInputs[i]=Object.assign({},inp)
  //           }
          }
        }
//         cl(this.initInputs[i])
//         cl(inp)
//         this.initInputs[i]=Object.assign({},inp)
//         cl(this.initInputs[i], inp)
//         this.initInputs[i]=Object.assign({},inp[i])
//         if(i==78){
//           cl(inp, this.initInputs[i])
//         }

      })
//       cl(arr)
//       cl(arr[0]?.d)
      sendArray(arr,this.zone.virtual,this.zone.gatewayType).then(r=>{
        globs.events.publish("saveOK",true)
      })
    }
  }

  setLightEmaTc=(inp,inpI,ofs,zInd,ch,now,arr)=>{
// C20C22-4549: the controller sets a generic sensor's EMA TC to 5s when it is
// mapped to Light on the device; do the same when it is mapped from the cloud,
// unless the EMA TC was already set to something other than 0
    let isLight=t=>((+t)&0x0FF)==constant.GENTYPE_LGHT
    if(!isLight(inp.sensorType)||isLight(inpI?.sensorType)){return}
    if(!supportsGenericEmaTc(this.zone?.gatewayId)){return}
    let i=ofs+getParamId2(1900,"pearl_gen_sens_conf","emaTc")
    if(+(dbVals.z[zInd]?.[ch]?.[i]||0)!=0){return}
    putZValue(zInd,ch,i,5)
    arr.push({c:ch,d:5,f:2,i:i,t:now,z:zInd})
  }

  loadInputMap=()=>{
    let gwType=this.zone?.gatewayType||1900
    let zInd=this.zone.siteZoneIndex
    let ch=240
    let tab=pInd[gwType]?.pearl_sensor_config
    let tab2=pInd[gwType]?.pearl_gen_sens_conf||{}
    this.inpMapIds={
      mappingId:getParamId2(1900,"pearl_sensor_config","mapping"),
      channelId:getParamId2(1900,"pearl_sensor_config","channel"),
      boardId:getParamId2(1900,"pearl_sensor_config","board"),
      base:tab ? tab[0] : tab,
      entSize:tab ? tab[2]: tab,
      entCnt:tab? tab[3]: tab,

      mappingId2:getParamId2(1900,"pearl_gen_sens_conf","mapping"),
      channelId2:getParamId2(1900,"pearl_gen_sens_conf","channel"),
      boardId2:getParamId2(1900,"pearl_gen_sens_conf","board"),
      typeId2:getParamId2(1900,"pearl_gen_sens_conf","sensorType"),
      entSize2:tab2[2],
      entCnt2:tab2[3],

    }
    let imi=this.inpMapIds;

    let inputs

    if (imi.entCnt && imi.entCnt2) {
      inputs=[...Array(imi.entCnt+imi.entCnt2)].map((ic,i)=>{
        //     let inputs=[...Array(imi.entCnt)].map((ic,i)=>{
              if(i<imi.entCnt){
                let ofs=i*imi.entSize
                return{
                  mapping:dbVals.z[zInd][ch][imi.mappingId+ofs],
                  channel:dbVals.z[zInd][ch][imi.channelId+ofs],
                  board:dbVals.z[zInd][ch][imi.boardId+ofs],
                }
              }else{
                let ofs=(i-imi.entCnt)*imi.entSize2
        //         cl(dbVals.z[zInd][ch][imi.mappingId2+ofs]||0)
                let mapping=dbVals.z[zInd][ch][imi.mappingId2+ofs]||0
                let sensorType=dbVals.z[zInd][ch][imi.typeId2+ofs]||0
                if(+sensorType==0){mapping=0}
                return{
                  mapping,
                  channel:dbVals.z[zInd][ch][imi.channelId2+ofs]||0,
                  board:dbVals.z[zInd][ch][imi.boardId2+ofs]||0,
                  sensorType,
                }
              }
            })
    }
//     cl(imi)
//     cl(imi.entCnt+imi.entCnt2)

//     cl(inputs[78])
    return inputs
  }

  loadExpansions=()=>{
    let gwType=this.zone.gatewayType
    let zInd=this.zone.siteZoneIndex
    let ch=240
    let tab=pInd[gwType]?.config_expansion_boards
//     cl(tab)
    let startInputId=getParamId2(gwType,"configuration_expansion_boards","startInput")
    let numInputId=getParamId2(gwType,"configuration_expansion_boards","numInputs")
    let boardTypeId=getParamId2(gwType,"configuration_expansion_boards","boardType")
    let mult=tab ? tab[2] : tab
    let cnt=tab ? tab[3] : tab
    this.c2bc={}
    this.bc2c={}
    this.b2type={};
    [...Array(cnt)].forEach((x,i)=>{
//       cl(i)
      let ofs=i*mult
      let pid=startInputId+ofs
      let board=i
      let start=+dbVals.z[zInd][ch][startInputId+ofs]||0
      let count=+dbVals.z[zInd][ch][numInputId+ofs]||0
//       cl("here")
      let bType=+dbVals.z[zInd][ch][boardTypeId+ofs]||0
//       cl(bType)
//       cl(getPearlNumIO(bType))
//       let count=(getPearlNumIO(bType)||{})[1]
      if(true||(bType!=0)){this.b2type[i]=bType}
      if(true||bType){
        this.bc2c[i]={}
        for(let j=0;j<count;j++){
          let ch=start+j// j is the channel on the board, ch is global, i is the board
          this.c2bc[ch]=[i,j]
          this.bc2c[i][j]=ch
        }
      }
    })
//     cl("here")
//     cl(this.bc2c)
  }

  loadInfo=async()=>{
// get mapping, board, chan for 128 entries:
    let maps=[]
    let pa=this.props.parms
    this.zone=globs.zonesInfo.info.filter(z=>{return z.zoneId==pa.zone})[0]
//     cl(this.zone)
    await gmbAddXBoardShorts(this.zone.gatewayId)
    await loadSensorsInfo()// for custom Generic Sensor names
//     cl(xBoardShorts)
//     cl(xBoardShorts[112])
    let inputs=this.loadInputMap()
    this.initInputs=inputs?.slice(0)
//     cl("here")
    this.loadExpansions()
//     cl("here")
    this.pearlUsed=getPearlUsed(this.zone.siteZoneIndex)
//     cl(this.pearlUsed)
//     Object.assign(this.state,{loaded:true,inputs:inputs})
//     cl(inputs)
    this.setState({loaded:true,inputs:inputs})
//       cl("ready")

  }

  pageChanged=false

  onPageChange=()=>{
    globs.events.publish("savePageEnable",true)
    this.pageChanged=true
  }

  onChange=(type,vals)=>{
    let st=this.state
//     cl(st)
//     cl(type,vals)
    var id,ind,inputs,bc
    switch(type){
      case "map":
//         globs.events.publish("savePageEnable",true)
        this.onPageChange()
        id=Object.keys(vals)[0]
//         cl(vals,id)
        ind=pearlSensorIds[id].i
        inputs=st.inputs.slice(0)
        let { board, sensorType, channel}=inputs[ind]
//         let board=inputs[ind].board
        if(!vals[id]){// if type none, reset values
          sensorType=0
          board=0
          channel=0
        }
//         cl(vals[id])
        if([lc.setup_t_InputMap_INPUTNAME_SENSOR_DTH,
          lc.setup_t_InputMap_INPUTNAME_MBUS_INPUT]
          .includes(+vals[id])/*==lc.setup_t_InputMap_INPUTNAME_SENSOR_DTH*/){
          board=Object.keys(this.bc2c)[0]
//           cl(this.bc2c)
//           cl(board)
        }
        inputs[ind]=Object.assign({},inputs[ind],{
          mapping:vals[id],
          sensorType,
          board,
          channel,
//           board:board
        })// creates new object
//         cl(board)
//         cl(ind)
//         cl(inputs[ind])
//         cl(inputs)
        this.setState({inputs:inputs})
        break
      case "sensorType":
//         cl(this.initInputs[79])
//         globs.events.publish("savePageEnable",true)
        this.onPageChange()
        id=Object.keys(vals)[0]
        inputs=st.inputs.slice(0)
        ind=pearlSensorIds[id].i
        inputs[ind]=Object.assign({},inputs[ind],{sensorType:vals[id]})
//         cl(st)
        this.setState({inputs:inputs})
        break
      case "board":

//         globs.events.publish("savePageEnable",true)
        this.onPageChange()
        id=Object.keys(vals)[0]
        ind=pearlSensorIds[id].i
        inputs=st.inputs.slice(0)
        bc=this.bc2c[vals[id]]// keyval of the channels on the board
//         cl(bc)
//         cl(id)
//         cl(vals[id])
        inputs[ind]=Object.assign({},inputs[ind],
          {board:+vals[id],
          channel:+(Object.keys(bc)[0])||0})// creates new object
        this.setState({inputs:inputs})
        break
      case "bChan":
//         globs.events.publish("savePageEnable",true)
        this.onPageChange()
        id=Object.keys(vals)[0]
        ind=pearlSensorIds[id].i
        inputs=st.inputs.slice(0)
        inputs[ind]=Object.assign({},inputs[ind],
          {channel:+vals[id]})// creates new object
        this.setState({inputs:inputs})
        break
      case "chan":
//         globs.events.publish("savePageEnable",true)
        this.onPageChange()
        id=Object.keys(vals)[0]
        ind=pearlSensorIds[id].i
        inputs=st.inputs.slice(0)
        bc=this.c2bc[vals[id]]
//         inputs[ind].board=bc[0]
//         inputs[ind].channel=bc[1]
        inputs[ind]=Object.assign({},inputs[ind],{board:bc[0],channel:bc[1]})// creates new object
        this.setState({inputs:inputs})
        break
    }
  }

// Generic Sensors use the custom name from Sensor Settings, if set
  getSensorLabel=(inp0)=>{
    let i=inp0.i
    if((i>=lc.setup_t_InputMap_INPUTIDX_GSNS1)&&(i<=lc.setup_t_InputMap_INPUTIDX_GSNS128)){
      let gn=i-lc.setup_t_InputMap_INPUTIDX_GSNS1
      let custom=getSensorsZone(this.zone?.zoneId)?.sensorNames?.[`e0gn${gn}`]
      if(custom){return custom}
    }
    return inp0.t
  }

  showSensorMappingSelect=(id)=>{
    let st=this.state
//     cl(id)
    let opts=Object.keys(this.inputIds)
      .filter(k=>{return this.inputTypes[id]?.opts.includes(+k)})
      .map(k=>{return{v:k,t:this.inputIds[k]}})
    let inp0=pearlSensorIds[id]

    let inp1=st?.inputs ? st?.inputs[inp0.i] : st?.inputs
    let types=this.inputTypes[id]?.opts
//     let info=pearlSensorIds[id]
    let parms={
      label:this.getSensorLabel(inp0),//inTemp:{i:1,t:"Inside Temperature"},
      breakLabel:true,
      valueName:id,
      opts:opts,
      onChange:(t,v)=>this.onChange("map",v),
    }
    parms[id]=+inp1?.mapping
    // controller stores DHT-T/DHT-H generic sensors as DTH (27); show it as Modbus Input
    if((inp0.i>=lc.setup_t_InputMap_INPUTIDX_GSNS1)&&(inp0.i<=lc.setup_t_InputMap_INPUTIDX_GSNS128)&&
      (parms[id]==lc.setup_t_InputMap_INPUTNAME_SENSOR_DTH)){
      parms[id]=lc.setup_t_InputMap_INPUTNAME_MBUS_INPUT
    }
//     cl(parms)
    return(
      <div style={{display:"inline-block"}}>
        <C18Select01 parms={parms}/>
      </div>
    )
  }

  showGenericSensorTypeSelect=(id)=>{
    let st=this.state
    let inp0=pearlSensorIds[id]
    let inp1=st.inputs[inp0.i]
//     cl(id)
//     cl(inp0)
//     cl(inp1)
    let parms={
      label:"",//inTemp:{i:1,t:"Inside Temperature"},
      valueName:id,
//       sensorType:inp1.sensorType,
      opts:/*this.*/genericTypes,
      onChange:(t,v)=>this.onChange("sensorType",v),
    }
    parms[id]=(+inp1.sensorType)&0x0FF
//     cl(parms)
    return(
      <div style={{display:"inline-block"}}>
        <C18Select01 parms={parms}/>
      </div>
    )
  }

  showSensorChanSelect=(id)=>{
//       cl("ready")
    let bTypes={
      "0":"None",					//  0: MB_SLAVE_TYPE_NONE
      "1":"24 Out",	//  1: MB_SLAVE_TYPE_24OUT
      "2":"8 Out",		//  2: MB_SLAVE_TYPE_8OUT
      "3":"4 Out",		//  3: MB_SLAVE_TYPE_4OUT
      "4":"2 Out",		//  4: MB_SLAVE_TYPE_2OUT
      "5":"EC/pH",				//  5: MB_SLAVE_TYPE_EC_PH
      "6":"2 An Out",		//  6: MB_SLAVE_TYPE_ANALOG_2OUT
      "7":"1 An Out",		//  7: MB_SLAVE_TYPE_ANALOG_1OUT
      "8":"3 An Out",		//  8: MB_SLAVE_TYPE_ANALOG_3OUT
      "9":"5 An Out",		//  9: MB_SLAVE_TYPE_ANALOG_5OUT
      "10":"Sensor",				// 10: MB_SLAVE_TYPE_SENSOR_MODULE
      "11":"An 16-In",				// 11: MB_SLAVE_TYPE_ANALOG_16INPUT
      "12":"A 8I/D 8O",		// 12:  MB_SLAVE_TYPE_CONTROLLER
      "13":"8 An+DTH",        // 13:  MB_SLAVE_TYPE_ANALOG_10IN_DHT
      "14":"4A/4D Out",		// 14:  MB_SLAVE_TYPE_4A_4D_OUTPUT
      "15":"DTH",		// 15:  MB_SLAVE_TYPE_DTH
      "16":"5 An+DTH",		// 16:  MB_SLAVE_TYPE_ANALOG_7IN_DHT
      "17":"2.5 DTH",		// 16:  MB_SLAVE_TYPE_DTH_5
      "18":"4 DO+DTH",		// 16:  MB_SLAVE_TYPE_4D_DTH
      "19":"8Out DTH",		// 16:  MB_SLAVE_TYPE_8OUT_DTH
      "20":"4AO+DTH",		// 20:  MB_SLAVE_TYPE_ANALOG_4OUT_DTH
      "21":"2O DTH",		// 17:  MB_SLAVE_TYPE_CONTROLLER
      "22":"5In Irr",		// 17:  MB_SLAVE_TYPE_CONTROLLER
      "23":"JPro",		// 17:  MB_SLAVE_TYPE_CONTROLLER
      "101":"Pearl An",		// 17:  MB_SLAVE_TYPE_PEARL_ANALOG
    }
    let dthTypes=[15,16,17,18,20]
    let tmpTypes=[0,1,6,7,8,9,10,11,45,58,59,60,61,62,63,64,65,66,67,
      68,69,70,71,72,73,74,75,76]
    let humTypes=[2,22,44,46]// 22 = INPUTIDX_FBINHUM (Fallback Humidity)
//     cl(id)
//     cl(xBoardShorts,this.b2type[b])
    var showBoardSelect=()=>{
      let boards=Object.keys(xBoardShorts).map(b=>{
//         if(id=="genSens3"){cl(b)}
        return{v:b,t:`Bd ${+b+1} (${xBoardShorts[+this.b2type[b]]})`}})
      let parms={
        valueName:id,
        opts:boards,
        onChange:(t,v)=>this.onChange("board",v),
      }
      parms[id]=inp1.board
//       cl(parms)
      return(
        <div style={{display:"inline-block"}}>
          <C18Select01 parms={parms}/>
        </div>
      )
    }
    var showChanSelect=()=>{
      let bdType=this.b2type[+inp1.board]
      var arr=[]
      let chPref="Ch"
      let sensorType=pearlSensorIds[id].i
//       cl(sensorType)
//       cl(inp1)
      let isDth=lc.setup_t_InputMap_INPUTNAME_SENSOR_DTH==+inp1.mapping
      if((isDth)&&
        dthTypes.includes(bdType)){
        if(tmpTypes.includes(sensorType)){chPref="T"}
        if(humTypes.includes(sensorType)){chPref="H"}
      }
//       if(id=="inTemp"){
//         cl(id,sensorType)
//       }
      if(isDth&&[constant.MB_SLAVE_TYPE_DTH_5,constant.MB_SLAVE_TYPE_ANALOG_7IN_DHT]
      .includes(bdType)){
        // 3 DTH channels for both temperature and humidity (H1-H3), matching the controller
        arr=[0,1,2]

      }else{
        arr=Object.keys((this.bc2c[inp1.board]||{}))
      }
      let chans=arr.map(c=>{
        return{v:c,t:`${chPref} ${+c+1}`}
      })
      let parms={
        valueName:id,
        opts:chans,
        onChange:(t,v)=>this.onChange("bChan",v),// "board channel"
      }
      parms[id]=inp1.channel
//       cl(parms)
      return(
        <div style={{display:"inline-block"}}>
          <C18Select01 parms={parms}/>
        </div>
      )
    }
// now, show board and channel
    let st=this.state
//       cl("ready")
//     cl(id)

    let chans=Object.keys(this.c2bc).sort().map(c=>{
      return{v:c,t:`Input Channel ${(+c)+1}`}
    })
    let opts=Object.keys(this.inputIds)
      .filter(k=>{return this.inputTypes[id]?.opts.includes(+k)})
      .map(k=>{return{v:k,t:this.inputIds[k]}})
    let inp0=pearlSensorIds[id]// the input type info

    let inp1=st.inputs[inp0.i]//the actual input info
//       cl("ready")
    let isModbus=((+inp1.mapping)==lc.setup_t_InputMap_INPUTNAME_MBUS_INPUT)
//     cl(id,isModbus)
//     cl(inp1)
//     cl(this.b2type)
//     cl(this.b2type[+inp1.board],constant.MB_SLAVE_TYPE_DTH_5)
//     if(id=="inTemp"){
//       cl(inp1)
//       cl(this.b2type)
//     }
    let isDth5=(inp1.mapping==lc.setup_t_InputMap_INPUTNAME_SENSOR_DTH)&&
    [constant.MB_SLAVE_TYPE_DTH_5,constant.MB_SLAVE_TYPE_ANALOG_7IN_DHT]
      .includes(this.b2type[+inp1.board])
//       (this.b2type[+inp1.board]==constant.MB_SLAVE_TYPE_DTH_5)
//       ([])
//       cl("ready")
    return(
      <div style={{display:"inline-block"}}>
        {showBoardSelect()}
        {(isModbus||isDth5)&&showChanSelect()}
      </div>
    )
  }

//   showSensorChanSelectO2=(id)=>{
//     let st=this.state
//     let chans=Object.keys(this.c2bc).sort().map(c=>{
//       return{v:c,t:`Input Channel ${(+c)+1}`}
//     })
// //     cl(chans)
//     let opts=Object.keys(this.inputIds)
//       .filter(k=>{return this.inputTypes[id]?.opts.includes(+k)})
//       .map(k=>{return{v:k,t:this.inputIds[k]}})
//     let inp0=pearlSensorIds[id]
//
//     let inp1=st.inputs[inp0.i]
//     let types=this.inputTypes[id].opts
// //     let info=pearlSensorIds[id]
//     let parms={
// //       label:inp0.t,//inTemp:{i:1,t:"Inside Temperature"},
//       valueName:id,
//       opts:chans,
//       onChange:(t,v)=>this.onChange("chan",v),
//     }
//     parms[id]=(this.bc2c[+inp1.board]||{})[+inp1.channel]
//
//     return(
//       <div style={{display:"inline-block"}}>
//         <C18Select01 parms={parms}/>
//       </div>
//     )
//   }

  showSensorChanSelectO=(id)=>{
    let st=this.state
    let inp0=pearlSensorIds[id]
    let inp1=st.inputs[inp0.i]
    let val="6"
    return(
      <div>chan
      <input type="number" min="1" max="128" step="1"
        value={val}
        onChange={e=>this.onChange("chan",e.currentTarget.value)}
      />
      </div>
    )
  }

  showSensor=(id,sensorId,i)=>{
//     cl(id,sensorId,i)
    let st=this.state
//     cl(st)
    let inp0=pearlSensorIds[id]
    let inp1=st?.inputs ? st?.inputs[inp0.i] : st?.inputs
    let isMbDth=[lc.setup_t_InputMap_INPUTNAME_MBUS_INPUT,lc.setup_t_InputMap_INPUTNAME_SENSOR_DTH]
      .includes(+inp1?.mapping)
    let isGSens=(sensorId>=lc.setup_t_InputMap_INPUTIDX_GSNS1)&&
      (sensorId<=lc.setup_t_InputMap_INPUTIDX_GSNS128)
//     cl(id)
//     cl(inp1)
    return(
      <tr key={i}>
        <td>
          {this.showSensorMappingSelect(id)}
          {(isMbDth)&&
            this.showSensorChanSelect(id)}
          {(isMbDth&&isGSens)&&
            this.showGenericSensorTypeSelect(id)}
        </td>
      </tr>
    )
  }

  getMapType=()=>{
    let {parms}=this.props
    let search=parms.parms.search
    let pos=search.indexOf("type=")
    return (pos>=0)?search.substring(pos+5):null
  }

  // Fallback Humidity is hidden (and never saved) on firmware that doesn't support it
  showInputType=(k)=>{
    return (k!="fbInHum")||supportsFallbackHum(this.zone?.gatewayId)
  }

  showSensors=()=>{
//     cl(lc.setup_t_InputMap_INPUTIDX_GSNS1)
    let st=this.state
//     cl(pearlSensorIds)
    let sensorList=[""]
//     cl(pearlSensorIds)
    let {parms}=this.props
    let search=parms.parms.search
    let pos=search.indexOf("type=")
//     let type=(pos>=0)?search.substring(pos+5):null
    let type=this.getMapType()
    if(!type){return}
//     cl(type)
//     cl(parms)
    let sensors=Object.keys(pearlSensorIds)
      .filter(s=>this.inputTypes[s]&&(!type||this.inputTypes[s].type==type))
      .filter(this.showInputType)
      .map((s,i)=>{
//       cl(s)
      return this.showSensor(s,pearlSensorIds[s].i,i)
    })
//     cl(sensors)
//     inTemp outTemp inHum inCo2 outLight winSpd anTemp1 anTemp2 anTemp3 anTemp4 anTemp5 fbInTemp
//     winDir soil1 soil2 soil3 soil4 soil5 rain irrTrig diffP inLight vent1 vent2 vent3 vent4 vent5
//     gen1 gen2 outHum locInTemp locInHum snow bpTemp baro volt1 volt2 volt3 volt4 volt5 volt6 volt7 volt8


    return(
      <table><tbody>
      {sensors}
      </tbody></table>
    )
  }

  render(){
    if(this.state.loaded){
      return(
        <div  id="pearl_mapping_table_01">
        {this.showSensors()}
        </div>
      )
    }else{
      return <LoadingSpinner message="loading equipment..." />
    }
  }
}

export default C18PearlMapping00;
